import { Controller } from '@hotwired/stimulus'

const BACK_TO_NORMAL_DELAY = 500

export default class extends Controller {
  static targets = ['root', 'clipboardIcon', 'checkIcon', 'button']
  static values = {
    clipboard: String,
    isInline: Boolean
  }

  declare readonly clipboardIconTarget: HTMLElement
  declare readonly checkIconTarget: HTMLElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly hasButtonTarget: boolean

  declare clipboardValue: string
  declare isInlineValue: boolean

  #hiddenClassName(): string {
    return this.isInlineValue ? 'hidden' : 'opacity-0'
  }

  copyValue(e: Event): void {
    e.preventDefault()
    e.stopPropagation()

    void navigator.clipboard.writeText(this.clipboardValue).then(() => {
      if (this.hasButtonTarget) {
        const icon = this.buttonTarget.querySelector('i')
        icon?.classList.remove('fa-clipboard')
        icon?.classList.add('fa-check')
        this.buttonTarget.disabled = true
      } else {
        const hiddenClassName = this.#hiddenClassName()
        this.clipboardIconTarget.classList.add(hiddenClassName)
        this.checkIconTarget.classList.remove(hiddenClassName)
      }
    })
  }

  mouseOut(): void {
    if (this.hasButtonTarget) {
      const icon = this.buttonTarget.querySelector('i')
      setTimeout(() => {
        icon?.classList.add('fa-clipboard')
        icon?.classList.remove('fa-check')
        this.buttonTarget.disabled = false
      }, BACK_TO_NORMAL_DELAY)
    } else {
      const hiddenClassName = this.#hiddenClassName()
      this.checkIconTarget.classList.add(hiddenClassName)
      setTimeout(() => {
        this.clipboardIconTarget.classList.remove(hiddenClassName)
      }, BACK_TO_NORMAL_DELAY)
    }
  }
}
